import { useState } from 'react';

export interface HoverHandlers {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

// Inline styles can't use :hover, so hover is tracked as state and merged into the
// style by the caller. Spread the handlers onto the element.
export const useHover = (): [boolean, HoverHandlers] => {
  const [hovered, setHovered] = useState(false);
  return [hovered, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) }];
};
